<template>
  <div v-if="activeDiscounts.length" class="card-discount-badges-container">
    <div
      v-for="discount in activeDiscounts"
      :key="discount.id"
      class="card-discount-badge"
      :style="{ width: width }"
      :class="discount.offer_day == 0 ? 'dis-long-weekend' : 'dis-long-sejour'"
      @mouseenter="showDiscountTooltip = discount.id"
      @mouseleave="showDiscountTooltip = null"
    >
      {{ getDiscountText(discount) }}
      <!-- Tooltip -->
      <div
        v-if="showDiscountTooltip === discount.id"
        class="card-discount-tooltip raleway-reg-p15"
      >
        Profitez de -{{ parseInt(discount.discount_percent) }}% dès plus de {{ discount.min_stay_nights - 1 || (discount.offer_day === 0 ? '2' : '7') }} nuits réservées
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardDiscountBadges',
  props: {
    lodging: {
      type: Object,
      required: true
    },
    width: {
      type: String
    }
  },
  data() {
    return {
      showDiscountTooltip: null
    };
  },
  methods: {
    getDiscountText(discount) {
      const baseText = discount.offer_day === 0 ? 'Offre long week-end' : 'Offre long séjour';
      return `${baseText} -${parseInt(discount.discount_percent)}%`;
    }
  },
  computed: {
    activeDiscounts() {
      if (!this.lodging.lodging_discounts || !this.lodging.lodging_discounts.length) {
        return [];
      }
      
      const validDiscounts = this.lodging.lodging_discounts;

      // Group discounts by category (offer_day)
      const weekendDiscounts = validDiscounts.filter(d => d.offer_day === 0);
      const sejourDiscounts = validDiscounts.filter(d => d.offer_day !== 0);

      const result = [];

      // Get max discount for weekend category
      if (weekendDiscounts.length > 0) {
        const maxWeekendDiscount = weekendDiscounts.reduce((max, current) => {
          return parseFloat(current.discount_percent) > parseFloat(max.discount_percent) ? current : max;
        });
        result.push(maxWeekendDiscount);
      }

      // Get max discount for séjour category
      if (sejourDiscounts.length > 0) {
        const maxSejourDiscount = sejourDiscounts.reduce((max, current) => {
          return parseFloat(current.discount_percent) > parseFloat(max.discount_percent) ? current : max;
        });
        result.push(maxSejourDiscount);
      }

      return result;
    }
  }
};
</script>

<style lang="scss" scoped>
.card-discount-badges-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 10px;

  @media screen and (max-width: 600px) {
    margin-top: 10px;
  }
}

.card-discount-badge {
  width: auto;
  min-width: 135px;
  height: 22px;
  padding: 4px 6px;
  border-radius: 16px;
  color: #3B6152;
  font-size: 12px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Raleway', sans-serif;
  position: relative;
}

.card-discount-tooltip {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 8px;
  padding: 8px 12px;
  background-color: #fff;
  color: #000;
  border: 2.44px solid #BFBFBF80;
  border-radius: 8px;
  white-space: nowrap;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

  &::after {
    content: '';
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 5px solid transparent;
    border-bottom-color: #fff;
  }

  @media screen and (max-width: 600px) {
    white-space: unset;
    width: 105%;
  }
}

@media screen and (min-width: 765px) {
  .card-hub-info .card-discount-tooltip {
    white-space: unset;
    width: 145%;
    left: 70%;
  }
}

.dis-long-weekend {
  background-color: #A5D3AE;
}

.dis-long-sejour {
  background-color: #CFE5DC;
}
</style>